import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { getOverallSettingsClasses, loadScrollMagic } from "../../utils/siteUtils";
import { mobileIs } from "../../utils/siteUtils";
import { BackgroundImage, Icon } from "../../elements";
import PrimaryButton from "../../elements/primary-button";
import "./style.scss";
import { gtag } from "../../utils";
import gsap from 'gsap';
import { debounce } from "lodash";
import Swiper from 'swiper';

const OwnersManual = props => {
	const { lang, rendering, fields, page } = props;
	const { title, list, colorScheme, iconName, buttonText, downloadIconName, downloadButtonText, all, downloadColorScheme } = fields;
	const isMobile = mobileIs()
	const swiper = useRef(null)
	const rootNode = useRef()
	const swiperEl = useRef()
	const isAR = page?.fields?.rtl?.value;
	const [data, setData] = useState([]);
	const [currentIndex, setCurrentIndex] = useState(0);
	const [detailList, setDetailList] = useState([]);
	
	const buildSwiper = () => {
	  const options = {
	    watchSlidesProgress: true,
	    slidesPerView: 'auto',
	    spaceBetween: isMobile ? 20 : 50,
	  }
	  swiper.current = new Swiper(swiperEl.current, options);
	}
	
  const changeCurrentIndex = (e, index) => {
		setCurrentIndex(index);
	};
	
	useEffect(() => {
		let allItem = [{
			fields: {
				title: {
					value: all?.value
				}
			}
		}];
		let data = all.value ? allItem.concat(list) : list;
		setData(data);
		buildSwiper();
	}, [list]);
	
	useEffect(() => {
		let allData = [];
		if(all.value) {
			if(currentIndex) {
				setDetailList(list[currentIndex-1].fields.list);
			} else {
				list.forEach((item) => {
					if(item?.fields?.list?.length) {
						allData = allData.concat(item.fields.list)
					}
				});
				setDetailList(allData);
			}
		} else {
			setDetailList(list[currentIndex].fields.list);
		}
	}, [currentIndex]);
	
	// 8.14新增埋点
	const downloadClk = (href) => {
		gtag('event', 'L_download_clk', {
			// 无参数
		});
		let a = document.createElement('a');
		a.setAttribute('href', href);
		a.download = 'file.pdf';
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	};
	
	const rootClasses = classNames("c-owners-manual", getOverallSettingsClasses(fields));
	return (
		<div className={rootClasses} ref={rootNode} datasourceid={rendering.dataSource}>
			<div className="back">
				<PrimaryButton {...{
				  colorScheme: colorScheme,
				  iconName: iconName,
					buttonText: buttonText,
					callback: () => {
					  window.history.go(-1);
					}
				}} />
			</div>
			<RichText tag="div" className="c-owners-manual_title" field={title} />
			<div className="c-owners-manual_swiper swiper" ref={swiperEl}>
			  <div className="swiper-wrapper">
			    {data && data.map((item, index) => (
			      <div className="swiper-slide" key={index} onClick={(e) => changeCurrentIndex(e, index)}>
			        <RichText tag="div" className={classNames("c-owners-manual_slidetitle", currentIndex == index ? 'active' : '')} field={item.fields.title} />
			      </div>
			    ))}
			  </div>
			</div>
			<div className="c-owners-manual_list">
				{detailList && detailList.map((item, index) => (
					<div className="c-owners-manual_list_item" key={index}>
						<RichText tag="div" className="c-owners-manual_list_item_name" field={item.fields.name} />
						{isMobile && <a download className="c-owners-manual_list_item_download cta-icon" href={item.fields?.pdf?.value?.src}>
							<Icon icon={{ ...downloadIconName.value }} />
						</a>}
						{!isMobile && <div className="c-owners-manual_list_item_download" onClick={(e) => downloadClk(item.fields?.pdf?.value?.src)}>
							<PrimaryButton {...{
							  colorScheme: downloadColorScheme,
							  iconName: downloadIconName,
								buttonText: downloadButtonText,
							}} />
						</div>}
					</div>
				))}
			</div>
		</div>
	)
}

export default 	OwnersManual;